import { Autoplay } from 'swiper/modules';

export const sliderSettings = {
    modules: [Autoplay],
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
    },
    pagination: false,
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    breakpoints: {
        320: {
            slidesPerView: 1.2,
        },
        640: {
            slidesPerView: 1.3,
        },
        1024: {
            slidesPerView: 2.3,
        },
        1440: {
            slidesPerView: 3.2,
        },
    },
};
